// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import SelectParticipants from './SelectParticipants';

export * from './fragments/ParticipantOption';

export default SelectParticipants;
